import styled, { css, keyframes } from 'styled-components';

/**
 * CustomLoader will render loader.
 * @constructor
 */

export const CustomLoader = (): JSX.Element => (
	<StyledLoaderContainer role="alert" aria-busy="true">
		<Loader1 />
		<Loader2 />
		<Loader3 />
	</StyledLoaderContainer>
);

const StyledLoaderContainer = styled.div(
	() => css`
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 15px;
	`
);

const grow = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  25% {
    transform: scale(1.8);
    opacity: 1;
  }
  50% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
`;

const LoadingAnimation = () => css`
	${grow} 0.7s linear infinite;
`;

const Loader = styled.div(
	({ theme: { color, spacing } }) => css`
		margin: ${spacing.xxxs} ${spacing.xs};
		width: 8px;
		height: 8px;
		background: ${color.loadingDot};
		border-radius: 100%;
	`
);

const Loader1 = styled(Loader)`
	animation: ${LoadingAnimation};
	animation-delay: 0s;
`;
const Loader2 = styled(Loader)`
	animation: ${LoadingAnimation};
	animation-delay: 0.1s;
`;
const Loader3 = styled(Loader)`
	animation: ${LoadingAnimation};
	animation-delay: 0.2s;
`;
